// import React, { useEffect, useRef, useState } from "react";
// import GradientButton from "./GradiantButton";
// import { investorApi } from "../../api/api";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { loginUser as loginUserAction } from "../../redux/reducers/userReducer";
// import Snackbar from "@mui/material/Snackbar";
// import Alert from "@mui/material/Alert";


// /* ================= CONSTANT STEPS ================= */

// const STEPS = {
//   EMAIL: "EMAIL",
//   LOGIN_PASSWORD: "LOGIN_PASSWORD",
//   REGISTER: "REGISTER",
//   OTP: "OTP",
// };

// const LoginModal = ({ onClose }) => {
//   const [snack, setSnack] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const showMessage = (message, severity = "success") => {
//     setSnack({
//       open: true,
//       message,
//       severity,
//     });
//   };


//   const navigate = useNavigate();
//   const modalRef = useRef();
//   const dispatch = useDispatch();

//   const [step, setStep] = useState(STEPS.REGISTER);
//   const [loading, setLoading] = useState(false);

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const [fullName, setFullName] = useState("");
//   const [phone, setPhone] = useState("");
//   const [agree, setAgree] = useState(false);

//   const [otp, setOtp] = useState("");

//   /* ================= ESC CLOSE ================= */

//   useEffect(() => {
//     const esc = (e) => e.key === "Escape" && onClose();
//     window.addEventListener("keydown", esc);
//     return () => window.removeEventListener("keydown", esc);
//   }, [onClose]);

//   /* ================= STEP 1 – CHECK EMAIL ================= */

//   const checkEmail = async () => {
//     if (!email) {
//       showMessage("Please enter your email", "warning");
//       return;
//     }

//     try {
//       setLoading(true);
//       const res = await investorApi.CheckEmail({ email });

//       if (res?.data?.exists) {
//         showMessage("Welcome back! Please enter your password.", "info");
//         setStep(STEPS.LOGIN_PASSWORD);
//       } else {
//         showMessage("Looks like you're new here. Let's create your account!", "info");
//         setStep(STEPS.REGISTER);
//       }

//     } catch {
//       showMessage("Failed to check email. Try again", "error");
//     } finally {
//       setLoading(false);
//     }
//   };


//   /* ================= LOGIN ================= */

//   const loginUser = async () => {
//     if (!password) {
//       showMessage("Please enter password", "warning");
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await investorApi.userLogin({ email, password });
//       const data = response.data;

//       dispatch(
//         loginUserAction({
//           user: {
//             id: data.user.id,
//             firstName: data.user.firstName,
//             lastName: "",
//             avatar: "",
//             role: data.user.role,
//             wallet: data.wallet,
//             Email: data.user.email,
//             Mobilenumber: data.user.mobileNumber,
//             isSubscribed: false,
//             isKyc: false,
//             refferal_code: data.user.refferal_code
//           },
//           token: data.token
//         })
//       );

//       localStorage.setItem("token", data.token);

//       showMessage("Login successful 🎉", "success");



//     } catch (err) {
//       showMessage("Invalid email or password", "error");
//     } finally {
//       setLoading(false);
//     }
//   };


//   /* ================= REGISTER ================= */

//   const registerUser = async () => {
//     if (!fullName || !phone) {
//       showMessage("Please fill all fields", "warning");
//       return;
//     }

//     if (!agree) {
//       showMessage("Please accept Terms & Privacy Policy", "warning");
//       return;
//     }

//     try {
//       setLoading(true);
//       await investorApi.SendEmailOtp({ email });
//       showMessage("OTP sent to your email 📧", "success");
//       setStep(STEPS.OTP);
//     } catch {
//       showMessage("Failed to send OTP", "error");
//     } finally {
//       setLoading(false);
//     }
//   };


//   /* ================= VERIFY OTP ================= */

//   const verifyOtp = async () => {
//     // if (!otp) {
//     //   showMessage("Please enter OTP", "warning");
//     //   return;
//     // }

//     try {
//       setLoading(true);
//       const response = await investorApi.VerifyOtp({
//         email,
//         otp,
//         fullName,
//         phone,
//       });
//       console.log(response.data);
//       const data = response.data;
//       dispatch(
//         loginUserAction({
//           user: {
//             id: data.user.ID,
//             firstName: data.user.FirstName,
//             lastName: "",
//             avatar: "",
//             role: data.user.role,
//             wallet: data.wallet,
//             Email: data.user.Email,
//             Mobilenumber: data.user.Mobilenumber,
//             isSubscribed: false,
//             isKyc: false,
//             refferal_code: data.user.refferal_code
//           },
//           token: data.token
//         })
//       );

//       localStorage.setItem("token", data.token);
//       showMessage("Login Successfull 🎉", "success");

//       setTimeout(() => {
//         onClose();
//       }, 1000);

//     } catch (err) {
//       showMessage("Please Enter Mobile number", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= RENDER ================= */

//   return (
//     <div style={styles.overlay} onClick={onClose}>
//       <div
//         style={styles.box}
//         ref={modalRef}
//         onClick={(e) => e.stopPropagation()}
//       >

//         {/* HEADER */}
//         <div style={styles.header}>
//           <span
//             style={styles.icon}
//             onClick={() =>
//               step === STEPS.EMAIL ? onClose() : setStep(STEPS.EMAIL)
//             }
//           >
//             ←
//           </span>
//           <div style={styles.title}> Sign In </div>
//           <span style={styles.icon} onClick={onClose}>✕</span>
//         </div>

//         {/* SUBTITLE */}
//         <div style={styles.subtitle}>
//           {step === STEPS.EMAIL && "Enter your Email ID"}
//           {step === STEPS.LOGIN_PASSWORD && "Enter your password"}
//           {step === STEPS.REGISTER}
//           {step === STEPS.OTP && "Enter OTP sent to your email"}
//         </div>

//         {/* ================= EMAIL STEP ================= */}
//         {step === STEPS.EMAIL && (
//           <>
//             <input
//               type="email"
//               placeholder="Email ID"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               style={styles.input}
//             />

//             <GradientButton
//               text={loading ? "Checking..." : "Continue"}
//               onClick={checkEmail}
//               width="100%"
//             />
//           </>
//         )}

//         {/* ================= LOGIN STEP ================= */}
//         {step === STEPS.LOGIN_PASSWORD && (
//           <>
//             <input value={email} disabled style={styles.input} />

//             <input
//               type="password"
//               placeholder="Password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               style={styles.input}
//             />



//             <div
//               style={styles.forgot}
//               onClick={() => navigate("/ForgetPassword")}
//             >
//               Forgot Password?
//             </div>


//             <GradientButton
//               text={loading ? "Logging in..." : "Login"}
//               onClick={loginUser}
//               width="100%"
//             />
//           </>
//         )}

//         {/* ================= REGISTER STEP ================= */}
//         {step === STEPS.REGISTER && (
//           <>
//             {/* <input
//               placeholder="Full Name"
//               value={fullName}
//               onChange={(e) => setFullName(e.target.value)}
//               style={styles.input}
//             />

//              <input
//               type="email"
//               placeholder="Email ID"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               style={styles.input}
//             /> */}

//             <div style={styles.phoneWrapper}>
//               <span style={styles.countryCode}>+91</span>
//               <input
//                 type="tel"
//                 placeholder="Mobile Number"
//                 value={phone}
//                 maxLength={10}
//                 onChange={(e) => {
//                   const value = e.target.value.replace(/\D/g, "");
//                   setPhone(value);
//                 }}
//                 style={styles.phoneInput}
//               />
//             </div>

//             {/* <label style={styles.checkbox}>
//               <input
//                 type="checkbox"
//                 checked={agree}
//                 onChange={(e) => setAgree(e.target.checked)}
//               />
//               I agree to Terms & Privacy Policy
//             </label> */}

//             <GradientButton
//               text={loading ? "Loading..." : "Sign In"}
//               // onClick={registerUser}
//               onClick={verifyOtp}
//               width="100%"
//             />
//           </>
//         )}

//         {/* ================= OTP STEP ================= */}
//         {step === STEPS.OTP && (
//           <>
//             <input
//               placeholder="Enter OTP"
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//               style={styles.input}
//             />

//             <GradientButton
//               text={loading ? "Verifying..." : "Verify OTP"}
//               onClick={verifyOtp}
//               width="100%"
//             />
//           </>
//         )}

//         <Snackbar
//           open={snack.open}
//           autoHideDuration={3000}
//           onClose={() => setSnack({ ...snack, open: false })}
//           anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         >
//           <Alert
//             severity={snack.severity}
//             variant="filled"
//             onClose={() => setSnack({ ...snack, open: false })}
//             sx={{ width: "100%" }}
//           >
//             {snack.message}
//           </Alert>
//         </Snackbar>
//       </div>

//     </div>
//   );
// };

// export default LoginModal;

// /* ================= STYLES ================= */

// const styles = {
//   overlay: {
//     position: "fixed",
//     inset: 0,
//     backgroundColor: "rgba(0,0,0,0.55)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     zIndex: 9999,
//   },
//   box: {
//     backgroundColor: "#fff",
//     borderRadius: 8,
//     padding: 20,
//     width: "90%",
//     maxWidth: 380,
//     boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
//   },
//   header: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginBottom: 12,
//   },
//   title: {
//     flex: 1,
//     textAlign: "center",
//     fontSize: 18,
//     fontWeight: 600,
//     color: "black"
//   },
//   subtitle: {
//     textAlign: "center",
//     fontSize: 14,
//     color: "#666",
//     marginBottom: 16,
//   },
//   icon: {
//     cursor: "pointer",
//     fontSize: 18,
//     color: "black"
//   },
//   input: {
//     width: "100%",
//     padding: 10,
//     marginBottom: 12,
//     borderRadius: 6,
//     border: "1px solid #ccc",
//     fontSize: 15,
//   },
//   forgot: {
//     textAlign: "right",
//     fontSize: 13,
//     color: "#007bff",
//     cursor: "pointer",
//     marginBottom: 12,
//   },
//   checkbox: {
//     fontSize: 13,
//     marginBottom: 16,
//     display: "flex",
//     gap: 6,
//     alignItems: "center",
//     color: "black"
//   },
//   phoneWrapper: {
//     display: "flex",
//     alignItems: "center",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     padding: "0 10px",
//     marginBottom: 12,
//   },

//   countryCode: {
//     fontSize: 15,
//     color: "#000",
//     marginRight: 6,
//     fontWeight: 500,
//   },

//   phoneInput: {
//     flex: 1,
//     border: "none",
//     outline: "none",
//     padding: "10px 0",
//     fontSize: 15,
//   },
// };


import React, { useEffect, useRef, useState } from "react";
import GradientButton from "./GradiantButton";
import { api, investorApi } from "../../api/api";
import { useDispatch } from "react-redux";
import { loginUser as loginUserAction } from "../../redux/reducers/userReducer";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField, Link } from "@mui/material";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";

const LoginModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const modalRef = useRef();
  const location = useLocation();


  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [isVerifiedUser, setIsVerifiedUser] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const storedReferralCode = localStorage.getItem("referralCode");
  console.log("Stored referral code on login modal:", storedReferralCode);

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showMessage = (message, severity = "success") => {
    setSnack({ open: true, message, severity });
  };

  /* ================= ESC CLOSE ================= */
  useEffect(() => {
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onClose]);

  const handleLoginSuccess = (data) => {
    dispatch(
      loginUserAction({
        user: {
          id: data.user.id,
          firstName: data.user.firstName,
          lastName: data.user.lastName,
          avatar: data.user.avatar,
          role: data.user.role,
          wallet: data.wallet,
          Email: data.user.Email,
          Mobilenumber: data.user.Mobilenumber,
          isSubscribed: false,
          isKyc: false,
          refferal_code: data.user.refferal_code,
          isVerified: data.user.isVerified,
        },
        token: data.token,
      })
    );

    localStorage.setItem("token", data.token);
    showMessage("Login successful 🎉", "success");

    setTimeout(onClose, 800);
  };

  const signIn = async () => {
    if (phone.length !== 10) {
      showMessage("Please enter a valid 10-digit mobile number", "warning");
      return;
    }

    try {
      setLoading(true);

      // 🔹 First check user by phone
      const response = await investorApi.checkPhone({ phone });


      setIsVerifiedUser(response.data.isVerified);

      // 🔥 If verified → require password
      if (response.data.isVerified) {
        if (!password) {
          showMessage("Please enter your password", "warning");
          setLoading(false);
          return;
        }


        const loginRes = await api.login({
          userName: phone,
          password,
        });
        console.log(loginRes.data);
        handleLoginSuccess({
          user: loginRes.data,
          token: loginRes.data.token,
          wallet: loginRes.data.wallet,
        });
      } else {
        console.log(storedReferralCode);
        const otpRes = await investorApi.VerifyOtp({ phone, parentCode: storedReferralCode || "" });
        handleLoginSuccess(otpRes.data);
      }

    } catch (error) {
      console.error(error);
      showMessage("Login failed. Try again", "error");
    } finally {
      setLoading(false);
    }
  };



  /* ================= SIGN IN ================= */
  // const signIn = async () => {
  //   if (phone.length !== 10) {
  //     showMessage("Please enter a valid 10-digit mobile number", "warning");
  //     return;
  //   }

  //   try {
  //     setLoading(true);

  //     const response = await investorApi.VerifyOtp({
  //       phone,
  //     });

  //     const data = response.data;
  //     console.log(data);

  //     dispatch(
  //       loginUserAction({
  //         user: {
  //           id: data.user.id,
  //           firstName: data.user.firstName,
  //           lastName: data.user.lastName,
  //           avatar: data.user.avatar,
  //           role: data.user.role,
  //           wallet: data.wallet,
  //           Email: data.user.Email,
  //           Mobilenumber: data.user.Mobilenumber,
  //           isSubscribed: false,
  //           isKyc: false,
  //           refferal_code: data.user.refferal_code,
  //           isVerified: data.user.isVerified
  //         },
  //         token: data.token,
  //       })
  //     );

  //     localStorage.setItem("token", data.token);
  //     showMessage("Login successful 🎉", "success");

  //     setTimeout(onClose, 800);
  //   } catch {
  //     showMessage("Login failed. Try again", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div
        style={styles.box}
        ref={modalRef}
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div style={styles.header}>
          <div style={styles.title}>Sign In</div>
          <span style={styles.icon} onClick={onClose}>✕</span>
        </div>



        {/* PHONE INPUT */}
        <div style={styles.phoneWrapper}>
          <span style={styles.countryCode}>+91</span>
          <input
            type="tel"
            placeholder="Mobile Number"
            value={phone}
            maxLength={10}
            onChange={(e) =>
              setPhone(e.target.value.replace(/\D/g, ""))
            }
            style={styles.phoneInput}
          />
        </div>

        {isVerifiedUser && (
          <>
            <TextField
              fullWidth
              required
              label="Password"
              type={showPassword ? "text" : "password"}
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  "&:hover fieldset": {
                    borderColor: "#667eea",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#667eea",
                    borderWidth: 2,
                  },
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword((prev) => !prev)}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />


            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                mb: 4,
              }}
            >
              <Link
                component={RouterLink}
                to="/forget-password"
                state={{ from: location.state?.from }}
                underline="hover"
                sx={{
                  color: "#667eea",
                  fontWeight: 600,
                  fontSize: "0.95rem",
                  "&:hover": {
                    color: "#764ba2",
                  },
                }}
              >
                Forgot Password?
              </Link>
            </Box>
          </>
        )}

        {/* BUTTON */}
        <GradientButton
          text={loading ? "Signing In..." : "Sign In"}
          onClick={signIn}
          width="100%"
        />

        {/* SNACKBAR */}
        <Snackbar
          open={snack.open}
          autoHideDuration={3000}
          onClose={() => setSnack({ ...snack, open: false })}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            severity={snack.severity}
            variant="filled"
            onClose={() => setSnack({ ...snack, open: false })}
          >
            {snack.message}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

export default LoginModal;

/* ================= STYLES ================= */

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.55)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  box: {
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 20,
    width: "90%",
    maxWidth: 360,
    boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: "#000",
  },
  icon: {
    cursor: "pointer",
    fontSize: 18,
  },
  phoneWrapper: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "0 10px",
    marginBottom: 20,
  },
  countryCode: {
    fontSize: 15,
    marginRight: 6,
    fontWeight: 500,
    color: "black"
  },
  phoneInput: {
    flex: 1,
    border: "none",
    outline: "none",
    padding: "10px 0",
    fontSize: 15,
  },
  inputWrapper: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "0 10px",
    marginBottom: 20,
    width: "100%",
  },

  inputField: {
    flex: 1,
    border: "none",
    outline: "none",
    padding: "10px 0",
    fontSize: 15,
  },

  eyeIcon: {
    cursor: "pointer",
    fontSize: 16,
    marginLeft: 8,
  },
};